import header from '../header.component';

// vue-loader writes each SFC's compiled render/__scopeId onto its script module's default
// export. If both header SFCs pointed at header.component.ts directly they would share one
// object and the last-built template would render for both themes. The shallow copy gives
// this SFC its own component object while reusing all of the shared header logic.
export default { ...header };
